export const TITLE_ALREADY_TAKEN = "The title has already been taken.";
